// Contentful CMS Integration Service
// TODO: Configure Contentful credentials in environment variables
import { createClient } from 'contentful';

// TODO: Add these environment variables to .env file:
// REACT_APP_CONTENTFUL_SPACE_ID=your_space_id
// REACT_APP_CONTENTFUL_ACCESS_TOKEN=your_access_token
// REACT_APP_CONTENTFUL_ENVIRONMENT=master (or your environment)

const client = createClient({
  space: process.env.REACT_APP_CONTENTFUL_SPACE_ID || '',
  accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN || '',
  environment: process.env.REACT_APP_CONTENTFUL_ENVIRONMENT || 'master',
});

// TODO: Create these Content Types in Contentful:
// 1. 'landingPageContent' - Main landing page content
// 2. 'service' - Services section
// 3. 'teamMember' - Team members
// 4. 'testimonial' - Customer testimonials
// 5. 'contactInfo' - Contact information

export const contentfulService = {
  // Fetch main landing page content
  // TODO: Configure content type 'landingPageContent' with fields:
  // - heroTitle (Text)
  // - heroSubtitle (Rich Text)
  // - heroImage (Media)
  // - aboutTitle (Text)
  // - aboutDescription (Rich Text)
  async getLandingPageContent() {
    try {
      const response = await client.getEntries({
        content_type: 'landingPageContent',
        limit: 1,
      });
      
      return response.items[0]?.fields || null;
    } catch (error) {
      return null;
    }
  },

  // Fetch services for services section
  // TODO: Configure content type 'service' with fields:
  // - title (Text)
  // - description (Rich Text)
  // - icon (Text) - FontAwesome icon class
  // - order (Number) - for sorting
  async getServices() {
    try {
      const response = await client.getEntries({
        content_type: 'service',
        order: 'fields.order',
      });
      return response.items.map(item => item.fields);
    } catch (error) {
      return [];
    }
  },


  async getAbout() {
    try {
      const response = await client.getEntries({
        content_type: 'about',
         limit: 1,
      });
      return response.items[0]?.fields || null;
    } catch (error) {
      return [];
    }
  },

 async getFooter() {
    try {
      const response = await client.getEntries({
        content_type: 'footer',
         limit: 1,
      });
      return response.items[0]?.fields || null;
    } catch (error) {
      return [];
    }
  },

  // Fetch team members
  // TODO: Configure content type 'teamMember' with fields:
  // - name (Text)
  // - position (Text)
  // - description (Rich Text)
  // - image (Media)
  // - quote (Text)
  // - linkedinUrl (Text)
  // - instagramUrl (Text)
  // - order (Number)
  async getTeamMembers() {
    try {
      const response = await client.getEntries({
        content_type: 'teamMember',
        order: 'fields.order',
      });
      return response.items.map(item => item.fields);
    } catch (error) {
      return [];
    }
  },

  // Fetch testimonials
  // TODO: Configure content type 'Testimonial' with fields:
  // - customerName (Text)
  // - testimonialText (Rich Text)
  // - rating (Number)
  // - customerImage (Media) - optional
  async getTestimonials() {
    try {
      const response = await client.getEntries({
        content_type: 'testimonial',
      });
      return response.items.map(item => item.fields);
    } catch (error) {
      return [];
    }
  },

  // Fetch instalaciones (facilities)
  // TODO: Configure content type 'instalacion' with fields:
  // - title (Text)
  // - description (Text)
  // - image (Media)
  // - order (Number) - optional, for sorting
  async getInstalaciones() {
    try {
      const response = await client.getEntries({
        content_type: 'instalacion',
        order: 'fields.order',
      });
      return response.items.map(item => item.fields);
    } catch (error) {
      return [];
    }
  },

  // Fetch contact information
  // TODO: Configure content type 'contactInfo' with fields:
  // - address (Text)
  // - phone (Text)
  // - email (Text)
  // - emergencyPhone (Text)
  // - whatsappNumber (Text)
  // - socialMedia (JSON Object)
  async getContactInfo() {
    try {
      const response = await client.getEntries({
        content_type: 'contactInfo',
        limit: 1,
      });
      return response.items[0]?.fields || null;
    } catch (error) {
      return null;
    }
  },
};

export default contentfulService;